import { useAuth } from "./auth";

/**
 * Convenience hook for permission-based UI gating. Backed by the AuthProvider,
 * which fetches the current user's effective permissions on login.
 */
export const usePermissions = () => {
  const { permissions, can, isAdmin, isLoading } = useAuth();
  return { permissions, can, isAdmin, isLoading };
};
